// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__tUVkY","additionalInfo":"AgreementModal_additionalInfo__K6vNR"};